const EmailInfo = ({ emailInfo }) => {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-header-icon">✉️</span>
        <h3 className="card-header-title">Email Information</h3>
      </div>
      <div className="card-body">
        <div className="info-row">
          <span className="info-label">From</span>
          <span className="info-value">{emailInfo.from}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Email</span>
          <span className="info-value">{emailInfo.email}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Phone</span>
          <span className="info-value">{emailInfo.phone}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Policy Mentioned</span>
          <span className="info-value info-value--link">{emailInfo.policyMentioned}</span>
        </div>
      </div>
    </div>
  );
};

export default EmailInfo;
